var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPracticeAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98828 24.457C10.1992 24.457 10.5039 24.375 10.8086 24.2227C17.5234 20.7656 19.75 18.9492 19.75 14.7422V6.03516C19.75 4.65234 19.2109 4.14844 18.0508 3.66797C16.7617 3.12891 12.4727 1.61719 11.2188 1.19531C10.832 1.07812 10.3984 0.996094 9.98828 0.996094C9.58984 0.996094 9.15625 1.07812 8.76953 1.19531C7.50391 1.59375 3.21484 3.14062 1.9375 3.66797C0.777344 4.13672 0.238281 4.65234 0.238281 6.03516V14.7422C0.238281 18.9492 2.55859 20.6016 9.17969 24.2227C9.48438 24.3867 9.78906 24.457 9.98828 24.457Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeAdmin);
export default __webpack_public_path__ + "static/media/PracticeAdmin.8303ae422f8c811a9886197c6d76ed28.svg";
export { ForwardRef as ReactComponent };